module.exports = __webpack_public_path__ + "static/media/projectmanagementhome.cf4f359a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Help/assets/projectmanagementhome.png
// module id = 1872
// module chunks = 193